module.exports = __webpack_public_path__ + "media/images/badge/supercoppa-bracket-perfetto-3f44e0735d5fd85d86f85e742e2af26e.png";